import { sendMessage } from '../../../config/utils/message'
import { CORE_API_AKADEMIK } from '../../key/api'

const admin = localStorage.getItem("nama");
export async function getUser(nim) {
    try {
      const response = await CORE_API_AKADEMIK.get(
        "pengajuankrs/data/view?nim=" + nim
      );
      return response;
    } catch (err) {
        sendMessage(500)
    }
  }
  
  export async function getSemester(nim) {
    try {
      const response = await CORE_API_AKADEMIK.get("semester/dropdown?nim=" + nim);
      return response;
    } catch (err) {
        sendMessage(500)
    }
  }

export async function getBatalMk(nim,semester) {
    const params = {
        nim: nim,
        semester: semester
    }
    try {
        const response = await CORE_API_AKADEMIK.get('detail/batalmk', { params: params })
        return response
    }
    catch (err) {
        sendMessage(500)
    }
} 

export async function setStatus(id,nim,semester,type) {
    const data = {
      ...id,
      admin: admin,
      status: type
    };
    try {
      const response = await CORE_API_AKADEMIK.post(`detail/batalmk?nim=${nim}&semester=${semester}`,data);
      return response;
    } catch (err) {
        sendMessage(500)
    }
  }


